import { CircularProgress, TextField } from "@pankod/refine-mui";
import { UseModalFormReturnType } from "@pankod/refine-react-hook-form";

import { Modal } from "../modal";

export const Create: React.FC<UseModalFormReturnType> = ({
    register,
    formState: { errors },
    refineCore: { onFinish, formLoading },
    handleSubmit,
    modal: { visible, close },
    saveButtonProps,
}) => {
    return (
        <Modal
            isOpen={visible}
            onClose={close}
            title="Create an Organization"
            startIcon={formLoading ? <CircularProgress size="1rem" /> : null}
            submitText={formLoading ? "Loading" : "Create"}
            onSubmitClick={saveButtonProps.onClick}
            submitDisabled={saveButtonProps.disabled}
        >
            <form className="form" onSubmit={handleSubmit(onFinish)}>
                <TextField
                    label="Organization Name"
                    placeholder="Name"
                    margin="normal"
                    fullWidth
                    {...register("organizationName", {
                        required: "This field is required",
                    })}
                />
            </form>
        </Modal>
    );
};
